module.exports = __webpack_public_path__ + "img/browser.7eeb659c.svg";